import React from "react";
import Chart from "react-apexcharts";

const LineChart = () => {
  return (
    <div className="area">
      <MyArea />
    </div>
  );
};
function MyArea() {
  const data = {
    series: [
      {
        name: "series1",
        data: [65, 75, 63, 51, 52, 67, 89, 91, 73, 75, 95, 92],
      },
    ],
    options: {
      fill: {
        colors: ["#C484F3", "#fff", '#fff'],
      },
      grid:{
        show:true,
        strokeDashArray:5,
      },
      chart: {
        height: 200,
        type: "area",
        toolbar:{
          show:false
        }
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        width: 2,
        curve: "smooth",
        colors: ["#f799a354"],
      },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],

       labels:{
        show:true,
       
        style:{
          fontSize:'12px',
          fontWeight:600,
         
        }
       }
      },
      yaxis: {
        min: 0,
        max: 100,
        tickAmount: 4,
        labels: {
          align:'left',
          show: true,
          style: {
            fontSize: "12px",
            fontWeight: 600,
          },
          formatter: (value) => {
            return "$" + value + "K";
          },

        },
        axisBorder:{
          show:true,
          color:'#c7c7c7',
        }
      },
    },
  };

  return (
    <div>
      <div id="chart">
        <Chart
          options={data.options}
          series={data.series}
          type="area"
          height={250}
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
}

export default LineChart;
